"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackProductTileServiceInteraction = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackProductTileServiceInteraction(eventCategory, eventAction, eventLabel, eventData) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory,
        eventAction,
        eventLabel,
        ...(eventData ? { eventData } : undefined),
    });
}
exports.trackProductTileServiceInteraction = trackProductTileServiceInteraction;
//# sourceMappingURL=trackProductTileServiceInteraction.js.map